import React, { FC } from 'react'
import css from './text.module.scss'

type Props = {
  lines: number
}
const SLimited: FC<React.PropsWithChildren<Props>> = ({ lines, children }) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <div className={css.s_limited_text} style={{ '-webkit-line-clamp': lines }}>
    {children}
  </div>
)

export default SLimited
